import { render, staticRenderFns } from "./clients2.vue?vue&type=template&id=d4404e72"
import script from "./clients2.vue?vue&type=script&lang=js"
export * from "./clients2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports